import { Component, ElementRef, HostListener, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientEngagementService } from '../../services/patient-engagement.service';
import html2canvas from 'html2canvas';
import jspdf, { jsPDF } from "jspdf";
import moment from 'moment';
import { TransactionDetail } from '../../models/transactions.models';
import { StateService } from '../../services/history.state.service';
import { CommmonUtil } from '../utils/common.util';
import { SignatureSource, SignatureType } from '../../../SecurePatientCommunication/models/chat.enum';
import { TransactionService } from '../../services/transaction.service';

@Component({
  selector: 'app-payment-confirm',
  templateUrl: './payment-confirm.component.html',
  styleUrl: './payment-confirm.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class PaymentConfirmComponent implements OnInit {
  @ViewChild('paymentList', { static: false }) paymentList!: ElementRef;
  transDetails: any;
  selectedTransId: string = "";
  todayDate: any;
  signatureList: any = [];
  @ViewChild('content', { static: false }) content: any;
  @ViewChild('divID', { static: false }) divID: any;
  elinkParams: any = {};
  showTransactionSummary: any;
   copayValue: any;
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  paymentSuccess = false;
  signatureDone = false;
  selectedTransDetails: any;
  localToUtcFormat: string | undefined;
  approvalNum: boolean = false;
  isError: boolean = false;
  transactionAmt: any;
  constructor(
    private _activeRoute: ActivatedRoute, 
    private _peServie: PatientEngagementService,
    private stateService: StateService,
    private _router: Router,
    private commmonUtil: CommmonUtil,
    private _transService: TransactionService
  ) {
     const nav = this._router.getCurrentNavigation();
  const state = nav?.extras?.state;
  if (state?.['isError']) {
    this.isError = true;
  } else {
     this.paymentSuccess = true;
    this.transDetails = state?.['selectedCard'] || [];
    this.approvalNum = state?.['approvalNum'] || 0;
    this.transactionAmt = state?.['transactionAmt'] || 0;
  }
  if(state?.['isNonZeroCopay']){
    this.paymentSuccess = false;
  }
  }

  ngOnInit() {
    if (typeof window !== 'undefined' && window.top && window.top !== window.self) {
    window.top.location.href = window.location.href;
    return;
  }
      this.selectedTransId = localStorage.getItem("SelectedTransId")!== 'undefined' ? JSON.parse(localStorage.getItem("SelectedTransId") || '{}') : {};
      this.todayDate = moment().local().format("MM/DD/YYYY hh:mm:ss A")
     this.localToUtcFormat = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    const storedDetails = localStorage.getItem('selectedTransDetails');
    if (storedDetails && storedDetails !== 'undefined') {
      this.selectedTransDetails = JSON.parse(storedDetails);
    } else {
      this._transService.selectedTransaction$.subscribe((selectedTrans) => {
        this.selectedTransDetails = selectedTrans;
      });
    }
      this._activeRoute.queryParams.subscribe((params: any) => {
        if(params && Object.keys(params).length > 0){
            this.stateService.setWorldpayActive(false);
          this.signatureCheck();
          this.transactionStatusDetail(params);
        }

    });
     this.copayValue = localStorage.getItem('copayValue');
  }
  ngAfterViewInit(): void {
    this.adjustPaymentListHeight();
    window.addEventListener('resize', this.adjustPaymentListHeight.bind(this));
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.adjustPaymentListHeight();
  }
  adjustPaymentListHeight() {
    const deviceType = this.getDeviceType();
    let bottomHeight = 71;
    this.commmonUtil.adjustElementHeight(this.paymentList, deviceType, bottomHeight);
  }
  getDeviceType(): 'desktop' | 'tablet' | 'mobile' {
    const viewportWidth = window.innerWidth;
    if (viewportWidth <= 767) {
      return 'mobile';
    } else if (viewportWidth <= 1024) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  }
  makePrintReceiptPdf() { 
    var data: any = document.getElementById('pdfDownload') || null;
    var dom: any = document.createElement('div');
    const htmlStr = "<h1>PrimeRx Cloud!</h1>";
    if(data)
      {
         html2canvas(dom, { useCORS: false }) // useCORS is optional if your images are externally hosted somewhere like s3
          .then(canvas => {
            var aelement: any = document.createElement("div");
            aelement.innerHTML = htmlStr;
            const contentDataURL = canvas.toDataURL('image/png')
          let pdf = new jspdf('p', 'mm', 'a4');
          pdf.addImage(contentDataURL, 0, 0, 250, 170);
          pdf.save('Transaction Details.pdf');

        });
    }
  }

  async downloadReceipt() {
    let element: any = document.getElementById("pdfDownload");
    try {
       const canvas = document.createElement('canvas');
       html2canvas(element).then(function (canvas) {
           // Convert the canvas to blob
          canvas.toBlob(function (blob: any) {
               // To download directly on browser default 'downloads' location
               let link = document.createElement("a");
               link.download = "Transaction Details.png";
               link.href = URL.createObjectURL(blob);
               link.click();
          },'image/png');
        });
    } catch (error) {
      console.error("Error downloading receipt:", error);
    }
  }

  transactionStatusDetail(params: any) {
    const transDetail = new TransactionDetail();
    transDetail.primerxPayTransId = params?.primerxPayTransId;
    transDetail.TransSetupID = params?.transSetupID;
    transDetail.ApplicationTransId = params?.ApplicationTransId;
    transDetail.PharmacyNPI = params?.PharmacyNPI;
    if(transDetail?.ApplicationTransId && transDetail?.primerxPayTransId){
        this._peServie.transactionDetail(transDetail).subscribe((resp: any) => {
          if (resp){ 
            this.transDetails = resp;
            this.paymentSuccess = true;
          }
        },
        (error: any) => {
          // Handle transaction detail retrieval failure
          this.transactionFails('Transaction failed, please contact the administrator.');
        });
    }else {
      this.transactionFails('Transaction failed, please contact the administrator.');
    }
  }
  transactionFails(msg:any){
    this.stateService.setActiveSection('pendingPayments');
    this._router.navigate(["/PendingPayments"], {
      queryParams: { message: msg }
    });
  }
  goToPendingPaymentsList() {
    this.stateService.setActiveSection('pendingPayments');
    this._router.navigate(['/PendingPayments']);
  }

  signatureCheck() {
    const signatureData = localStorage.getItem('paymentSignature') ? JSON.parse(localStorage.getItem('paymentSignature') as string) : null;
    this.elinkParams = JSON.parse(localStorage.getItem('paramsData') as string);
    if (signatureData) {
      const payloadForsetupSaleSig = {
        signatureImageBase64: signatureData.replace(
          /^data:image\/(png|jpeg);base64,/,
          ''
        ),
        signatureSource: SignatureSource.MyPrimeRx,
        signatureType: SignatureType.Payment,
        SignatureDtTm: this.localToUtcFormat
      };
      this.signatureList = [payloadForsetupSaleSig];
      const payload = {
        transID: this.selectedTransDetails?.transID,
        npiNo: this.elinkParams?.npi,
        Signatures: this.signatureList,
      };
      this._peServie.addSignatureOnly(payload).subscribe((resp) => {
        if(resp){
          localStorage.removeItem('paymentSignature');
          localStorage.removeItem('selectedTransDetails');
        }
      });
    }
    // if (signatureData) this.signatureDone = signatureData ? true : false; // Show the summary section now
  }

  retryPayment(){
     this._router.navigate(['/process-payment']);
  }
}
